import { render, staticRenderFns } from "./CreateCardholder.vue?vue&type=template&id=35dbb41a"
import script from "./CreateCardholder.vue?vue&type=script&lang=js"
export * from "./CreateCardholder.vue?vue&type=script&lang=js"
import style0 from "./CreateCardholder.vue?vue&type=style&index=0&id=35dbb41a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports